var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26434 4.71398L3.3716 6.82123L5.47885 4.71398",
    stroke: "#FF1919",
    strokeWidth: 1.52056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37164 1.76382V6.82123",
    stroke: "#FF1919",
    strokeWidth: 1.52056,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.74321,
    height: 6.74321,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 7.66412)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/down-arrow.325957a1131ad141bdc5389a0b31ba89.svg";